import React from 'react';

// Material-ui
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
    container: {
        [theme.breakpoints.up('xs')]: {
            minWidth: '440px',
            width: '440px',
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },
    root: {
        marginTop: theme.spacing(12),
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'start',
        padding: '20px',
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    fullWidth: {
        width: '100%',
    },
    logo: {
        height: '30px',
        width: 'auto',
        margin: theme.spacing(3, 0, 2),
    },
}));

const Wellcome = () => {
    const classes = useStyles();
    const memberinfo = JSON.parse(localStorage.getItem('bw-member'));
    const LOYVERSE_CLIENT_ID = process.env.REACT_APP_LOYVERSE_CLIENT_ID;
    const LOYVERSE_API_URL = process.env.REACT_APP_LOYVERSE_API_URL;
    const LOYVERSE_BW_REDIRECT_URL = process.env.REACT_APP_LOYVERSE_BW_REDIRECT_URL;
    const LOYVERSE_PERMISSION_SCOPE = process.env.REACT_APP_LOYVERSE_PERMISSION_SCOPE;

    const redirecturl = `${LOYVERSE_API_URL}?client_id=${LOYVERSE_CLIENT_ID}&scope=${LOYVERSE_PERMISSION_SCOPE}&response_type=code&redirect_uri=${LOYVERSE_BW_REDIRECT_URL}&state=${memberinfo.BrandHash}`;

    return (
        <Container className={classes.container}>
            <div className={classes.root}>
                <img className={classes.logo} alt='BrandWallet Logo' src='assets/img/bw-logo-color-250x50.png' />
                <Typography className={classes.fullWidth} variant='body1' gutterBottom>{`Hi ${memberinfo.FullName},`}</Typography>
                <br />
                <Typography className={classes.fullWidth} variant='body1'>If you want to connect your BrandWallet account with your Loyverse account, please click on the button below.</Typography>
                <br />
                <Typography className={classes.fullWidth} variant='body1'>Thank you :)</Typography>
                <Button className={classes.submit}
                    fullWidth
                    size='large'
                    variant='contained'
                    color='primary'
                    href={redirecturl}
                >CONNECT</Button>
            </div>
        </ Container>
    );
}

export default Wellcome;